<template>
    <div
        class="w-full shadow-md rounded-md"
        :class="{
            'overflow-hidden': overflowHidden,
            'bg-white': this.color === 'white',
            'bg-red-200': this.color === 'red',
            'bg-green-200': this.color === 'green',
            'bg-blue-200': this.color === 'blue',
            'bg-gray-200': this.color === 'gray',
            'bg-gray-50': this.color === 'light-gray',
        }"
    >
        <div class="px-1 py-2 h-full">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppCard',
    props: {
        overflowHidden: {
            required: false,
            default: true,
            type: Boolean,
        },
        color: {
            required: false,
            default: 'white',
            type: String,
        },
    },
};
</script>
